import { ProductConsumptionCosts } from '@vae/server/src/modules/ExternalAPIs/Synerall/utils/costCalculators'
import { ProductOffers } from '@vae/server/src/types/synerallApiTypes'
import React from 'react'
import ProductShowcaseCard from '../../../../modals/getOurContract/components/ProductShowcaseCard'

interface SelectOfferStepProps {
	offers: ProductOffers
	onSelectOffer: (offer: ProductConsumptionCosts) => void
}

const SelectOfferStep: React.FC<SelectOfferStepProps> = ({ offers, onSelectOffer }) => {
	return (
		<div className='contracts'>
			{offers.offers.map(
				(offer: ProductConsumptionCosts, index: number) =>
					offer.product && (
						<ProductShowcaseCard
							key={index}
							showImage={false}
							product={offer.product}
							savings={0 - offer.costs.totalCost}
							maxKwh={offer.kwhLimit}
							isSpot={offer.costs.isSpot}
							onClick={() => onSelectOffer(offer)}
						/>
					)
			)}
		</div>
	)
}

export default SelectOfferStep
